import { InferGetStaticPropsType } from "next";
import {
  SignupSelectPreferencesGetStaticProps,
  SignupSelectPreferences,
} from "@chef/feature-signup";
import { useSectionData } from "@chef/feature-sanity";

const ChooseMealbox = ({
  signupStepOne,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  // TODO: Check if we will be using sanity data for the background image and bottom.
  const [sanityBanner] = useSectionData(signupStepOne);

  return <SignupSelectPreferences sanityBanner={sanityBanner} />;
};

export const getStaticProps = SignupSelectPreferencesGetStaticProps;

export default ChooseMealbox;
